import { gql } from '@apollo/client';

export const RESEND_CREDENTIALS_TO_PARENT = gql`
  mutation ResendCredentialsToParent($input: ResendCredentialsToParentInput!) {
    resendCredentialsToParent(input: $input) {
      parentId
    }
  }
`;
